export default "__VITE_ASSET__DtZeprj3__"